import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { api } from "@/lib/api";
import { scrollToId } from "@/lib/scroll";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { AnnouncementBar, useAnnouncement } from "@/components/AnnouncementBar";
import { HomeCarousel } from "@/components/HomeCarousel";
import { Ticker } from "@/components/Ticker";
import { Opportunities } from "@/components/Opportunities";
import { Manifesto } from "@/components/Manifesto";
import { Offerings } from "@/components/Offerings";
import { Insights } from "@/components/Insights";
import { WhyUs } from "@/components/WhyUs";
import { Consultation } from "@/components/Consultation";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";

export default function Home() {
  const [opportunities, setOpportunities] = useState([]);
  const [selectedShare, setSelectedShare] = useState("");
  const [user, setUser] = useState(null);
  const announcement = useAnnouncement();

  useEffect(() => {
    api.get("/opportunities").then((res) => setOpportunities(res.data)).catch(() => {});
    api.get("/auth/me").then((res) => setUser(res.data)).catch(() => {});
    const pre = sessionStorage.getItem("enquire_share");
    if (pre) {
      sessionStorage.removeItem("enquire_share");
      setSelectedShare(pre);
      setTimeout(() => scrollToId("#enquire"), 700);
    } else if (window.location.hash && !window.location.hash.includes("=")) {
      setTimeout(() => scrollToId(window.location.hash), 600);
    }
  }, []);

  return (
    <div data-testid="home-page">
      <Navbar />
      {announcement && <AnnouncementBar data={announcement} />}
      <Hero opportunities={opportunities} />
      <HomeCarousel announcement={announcement} opportunities={opportunities} />
      <Ticker opportunities={opportunities} />
      <Opportunities opportunities={opportunities} onEnquire={setSelectedShare} />
      <Manifesto />
      <Offerings />
      <Insights />
      <WhyUs />
      <Consultation />
      <LeadForm opportunities={opportunities} selectedShare={selectedShare} user={user} />
      <Footer />
      <a
        data-testid="whatsapp-float-button"
        href="https://wa.me/918169647280?text=Hi%20PRE-IPO%20EXPERT%2C%20I%27d%20like%20to%20know%20more%20about%20unlisted%20share%20opportunities."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-24 left-6 z-50 flex h-14 w-14 md:bottom-6 items-center justify-center rounded-full border border-emerald-600/50 bg-emerald-500 text-white shadow-[0_8px_30px_rgba(16,185,129,0.35)] transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle className="h-6 w-6" />
      </a>
    </div>
  );
}
